let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("0uXRI")).then(() => parcelRequire('xEGV6'));